import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: null,
        // 新增暗黑模式状态，默认从本地存储读取，防止刷新后失效
        isDarkMode: localStorage.getItem('driver_learning_dark_mode') === 'true'
    },
    mutations: {
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
        },
        CLEAR_USER_INFO(state) {
            state.userInfo = null
        },
        // 新增切换暗黑模式的方法
        TOGGLE_DARK_MODE(state) {
            state.isDarkMode = !state.isDarkMode
            localStorage.setItem('driver_learning_dark_mode', state.isDarkMode)
            // 动态为 html 标签切换滤镜类名
            if (state.isDarkMode) {
                document.documentElement.classList.add('dark-mode')
            } else {
                document.documentElement.classList.remove('dark-mode')
            }
        }
    },
    actions: {},
    modules: {}
})